<template>
<div class="find-by-vin">
    <div class="hnw-area-center by-body" :style="{'min-height':(viewportH)+'px'}">
        <div class="finvin-head" >
            <div class="veh-info">
                <div class="ml-title">
                    <img src="../../assets/vinpart/che.png" alt="" srcset=""> 
                </div>
                    车辆配置信息:
                    <div class="level-show-list" >
                        {{carInfo.vehicle_show_name}}
                    </div>
                <el-popover
                    placement="bottom"
                    width="200"
                    trigger="click"

                >
                   
                    <div class="btn" slot="reference">
                        详情
                    </div>
                    <!-- v-show="showMoreMsg" -->
                    
                    <div class="car-msg-info">
                        <el-tabs v-model="activeMsgTag" @click.stop >
                            <el-tab-pane label="车辆主要信息" name="main"></el-tab-pane>
                            <el-tab-pane label="车辆配置信息" name="other"></el-tab-pane>
                        </el-tabs>

                        <div class="msg-body">
                            <div class="msg-head">
                                <div v-if="activeMsgTag=='main'">主要信息</div>
                                <div v-else>配置号</div>
                                <div>说明</div>
                                
                            </div>
                            <div class="camsg-input-box" v-if="activeMsgTag=='other'">
                                <el-input size="mini" placeholder="输入关键字查询" v-model="carMsgfilterText"></el-input>
                            </div>
                            <div class="car-msg-body">
                                <div class="car-msg-row" v-if="activeMsgTag=='main'">
                                    <div class="label">
                                        车型:
                                        
                                    </div>
                                    <div class="value">
                                        {{carInfo.vehicle_name}}
                                    </div>
                                </div>
                                <template v-if="activeMsgTag=='main'">
                                    <div class="car-msg-row" v-for="(item,index) in carAllMsg" :key="index">
                                        <template v-if="item.type==0">
                                            <div class="label">
                                                {{item.name}}
                                            </div>
                                            <div class="value">
                                                {{item.value}}
                                            </div>
                                        </template>
                                    </div>
                                </template>
                                <template v-else-if="activeMsgTag=='other'">
                                    <div class="car-msg-row" v-for="(item,index) in showCarOtherMsg" :key="index">
                                        <div class="label o-label">
                                            {{item.name}}
                                        </div>
                                        <div class="value">
                                            <el-tooltip  effect="dark" :open-delay="300" :content="item.value" placement="top">
                                                <span >
                                                    {{item.value}}
                                                </span>
                                            </el-tooltip>
                                            
                                        </div>
                                        
                                    </div>
                                </template>
                            </div>
                            
                        </div>
                    </div>
                </el-popover>
                 <span  class="head-option" >
                    <!-- <el-tooltip class="item" effect="dark" content="当日查询重复vin不扣费" placement="top-end">
                        <i class="el-icon-info" ></i>
                    </el-tooltip> -->
                    <!-- e -->
                    剩余 vin次数
                    <span class="red">
                        {{$store.state.vinNum}}
                    </span>
                    译码次数
                    <span class="red">
                        {{$store.state.decode_amount}}
                    </span>
                </span>
            </div>
            <div class="head-right">
                <div class="btn" @click="showGoodsList">
                    生成表格
                </div>
            </div>
        </div>

        <div class="result-body">
            <div class="result-left">
                <el-card shadow="never">
                    <div slot="header" class="clearfix">
                        <span>需求清单</span>
                    </div>
                    
                    <div class="part-name-box">
                            <!-- autosize -->
                        <el-input
                            type="textarea"
                            :rows="10"
                            placeholder="请输入需求清单,多个需求用换行或者逗号分隔"
                            v-model="partNames"
                            resize="none"
                        >
                        </el-input>
                    </div>
                    
                    <div class="btns">
                        <el-button size="small" @click="partNames=''">清空</el-button>
                        <div class="btn"  @click="vinSearch(1)" >
                            立即译码
                        </div>
                        <!-- <el-button @click="vinSearch" type="primary" size="small">立即译码</el-button> -->
                    </div>
                </el-card>
            </div>
        
            <div class="result-right">
                <el-table
                    header-row-class-name="head-bold"
                    :row-style="getRowStyle"
                    
                    :data="demandList"
                    :span-method="spanMethod"
                    border
                    style="width: 100%"
                    v-loading="demaLoading"
                >
                    <!-- highlight-current-row -->
                    <!-- :span-method="mergeSameTitleRows" -->
                    <el-table-column
                        prop="title"
                        label="需求项"
                        width="90">
                        <template #default="scope">
                            <div class="item-row">
                                <div class="label" @click.stop="deleteRow(scope.$index, demandList,scope.row,'1')"><i class="el-icon-close"></i></div>
                                <div class="value">{{ scope.row.title }}</div>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column
                       
                        label="分类/配件名称"
                        width="110">
                        
                        <template #default="scope">
                            <div class="item-row" >
                                <!-- <div class="label"><i class="el-icon-close"></i></div> -->
                                <div class="value" v-if="scope.row.partInfo">{{ scope.row.partInfo.part_group_name ||scope.row.partInfo.part_name }}</div>
                            </div>
                        </template>
                    </el-table-column>
                    
                    <el-table-column
                        prop="part_number"
                        label="原厂OE号"
                        width="140">
                        <template #default="scope">
                            <!-- <div v-if="scope.row.partList.length>0">

                            </div> -->
                           <!-- &&!scope.row.isChild -->
                            <!-- <div v-if="scope.row.partList.length>1&&!scope.row.partInfo">
                                <el-button @click="showPartList(scope.row)" type="text" size="small">选择译码</el-button>
                            </div> -->

                            <div v-if="scope.row.isHand&&!scope.row.partInfo.part_number">
                                <el-button @click.stop="toVinFind(scope.row)" type="danger" plain size="small">
                                    手工译码
                                    <!-- {{ scope.row.children.length==0?"手工译码":"手工译码1"}} -->
                                </el-button>
                            </div>
                            <div v-else>
                                
                                <div class="item-row">
                                    <!-- <div class="label"><i class="el-icon-close" @click="scope.row.partInfo=''"></i></div> -->
                                     <!-- v-if="scope.row.isChild" -->
                                    <div class="label" ><i class="el-icon-close" @click.stop="deleteRow(scope.$index, demandList,scope.row,'2')"></i></div>
                                    <div class="value" v-if="scope.row.partInfo">{{ scope.row.partInfo.part_number }}</div>
                                    <img class="boom-img" v-if="scope.row.partInfo&&scope.row.partInfo.pots_number" @click.stop="readBoom(scope.row.partInfo)" src="../../assets/index/ym-boom.png" alt="" srcset="">
                                    <!-- <div class="label" v-if="scope.row.partInfo&&scope.row.partInfo.pots_number" @click.stop="readBoom(scope.row.partInfo)"><i class="el-icon-zoom-in"></i></div> -->
                                </div>
                                
                                <!-- <div class="part-name" v-if="scope.row.isHand&&!scope.row.isChild">
                                    <el-button @click.stop="toVinFind(scope.row)" type="danger" plain size="small">重新选择</el-button>
                                </div> -->
                                <!-- 俄   -->
                                <div class="part-name"  :title="scope.row.partInfo.part_name">{{ scope.row.partInfo.part_name }}</div>
                            </div>
                            
                        </template>

                    </el-table-column>
                   
                    <el-table-column
                        
                        label="配件信息"
                        width="360"
                    >
                        <template #default="scope">

                            <div class="goods-item" v-if="scope.row.goodsInfo&&scope.row.goodsInfo.goods_id">
                                    <div class="info-left">
                                
                                    <HnwOssImg  :src="scope.row.goodsInfo.goods_image" :preview="true" :width="60" :id="scope.row.goodsInfo.goods_id"></HnwOssImg>
                                    </div>

                                    <div class="info-right">
                                    <div class="goods-name">
                                        <div class="name-tag" :title="scope.row.goodsInfo.goods_name">
                                            <div class="name-text" :title="scope.row.goodsInfo.goods_name">
                                                 {{ scope.row.goodsInfo.goods_name }}
                                            </div>
                                            
                                            <div class="tag-icon" v-if="scope.row.goodsInfo.isPep">
                                                互
                                            </div>
                                        </div>
                                        <!-- <el-button v-if="scope.row.goodsInfo" @click="demandRowClick(scope.row)" type="text" size="small">互换件</el-button> -->
                                        <div class="btns">
                                            <!--  -->
                                            <div class="hand-btn"  v-if="scope.row.goodsInfo.buyHisList&&scope.row.goodsInfo.buyHisList.length>0"  @click="readHisList(scope.row.goodsInfo)">
                                                购买记录
                                            </div>
                                            <div class="hand-btn"  @click="demandRowClick(scope.row)">
                                                4S价
                                            </div>
                                        </div>
                                    </div>
                                        <div class="goods-row">
                                            <div class="item-row oe-row"  :title="scope.row.goodsInfo.oecode" @click="copy(scope.row.goodsInfo.oecode)">
                                                <div class="label">OE:</div>
                                                <div class="value">{{ scope.row.goodsInfo.oecode }}</div>
                                            </div>
                                            <div class="item-row sc-row"  :title="scope.row.goodsInfo.sccode" @click="copy(scope.row.goodsInfo.sccode)">
                                                <div class="label">生产码:</div>
                                                <div class="value">{{ scope.row.goodsInfo.sccode }}</div>
                                            </div>
                                            
                                        </div>
                                        <div class="goods-row">
                                            <div class="item-row pp-row" :title="scope.row.goodsInfo.oenaturebrand">
                                                <div class="label">品牌:</div>
                                                <div class="value">{{ scope.row.goodsInfo.oenaturebrand }}</div>
                                            </div>
                                            <div class="item-row gg-row" :title="scope.row.goodsInfo.spec">
                                                <div class="label">规格:</div>
                                                <div class="value">{{ scope.row.goodsInfo.spec }}</div>
                                            </div>
                                            <div class="item-row">
                                                <div class="label">库存:</div>
                                                <div class="value">
                                                    <span v-if="$store.state.look_inv==1">
                                                        
                                                        {{scope.row.goodsInfo.goods_storage}}
                                                    </span>
                                                    <span v-else>
                                                        {{scope.row.goodsInfo.goods_storage>0?"有货":"无货"}}
                                                    </span>
                                                </div>

                                            </div>
                                            <!-- 
                                                <div class="item-row" v-if="scope.row.goodsInfo.buyHisList&&scope.row.goodsInfo.buyHisList.length>0" >
                                                    <div class="value">
                                                        <div class="btn"  @click.stop="readHisList(scope.row.goodsInfo)">
                                                            购买记录
                                                        </div>
                                                    </div>
                                                </div> 
                                                
                                            -->
                                        </div>
                                        <div class="goods-row">
                                            <div class="item-row vehicle-row" :title="scope.row.goodsInfo.vehicletype">
                                                <div class="label">适配车型:</div>
                                                <div class="value">{{ scope.row.goodsInfo.vehicletype }}</div>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                            
                            <div v-else>
                                
                            </div>
                            
                        </template>
                    </el-table-column>
                    <el-table-column
                       
                        label="销售价"
                        width="80" 
                    >
                        
                        <template #default="scope">
                            <span v-if="scope.row.goodsInfo">
                                {{ scope.row.goodsInfo.goods_price }}
                            </span>
                            <span v-else>
                                
                            </span>
                        </template>

                    </el-table-column>
                    <el-table-column
                        
                        label="数量"
                        width="110">
                        <template #default="scope">
                            <!-- <el-input
                              v-if="scope.row.goodsInfo"
                              size="mini"
                              :min="1"
                              v-model="scope.row.goodsInfo.goods_num"
                              type="number"
                            >
                            </el-input> -->
                            <div v-if="scope.row.goodsInfo">
                                <el-input-number   v-if="$store.state.zero_buy==1" v-model="scope.row.goodsInfo.goods_num" :min="1"  size="mini"></el-input-number>
                                <el-input-number   v-else  v-model="scope.row.goodsInfo.goods_num"  @change="impueNumChange(scope.row.goodsInfo)" :min="1"  size="mini"></el-input-number>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        label="操作"
                        width="100">
                        <template slot-scope="scope">
                            <div class="btn" v-if="scope.row.goodsInfo" :class="{'add-btn':scope.row.goodsInfo.goods_storage==0}" @click="joinCart(scope.row.goodsInfo)">
                                {{scope.row.goodsInfo.goods_storage>0?'加入购物车':'加入预购单'}}
                            </div>
                            <!-- <el-button v-if="scope.row.goodsInfo" @click.stop="joinCart(scope.row.goodsInfo)" type="text" size="small">{{scope.row.goodsInfo.goods_storage > 0 ? "加入购物车" : "加入预购单"}}</el-button> -->
                        </template>
                    </el-table-column>
                    
                </el-table>

            </div>
        </div>
        <el-dialog
			:visible.sync="moreScdVis"
            title="配件列表"
			top="20vh"
            width="1000px"
            @row-click="partRowClick"
			>
            <div class="part-vis-list">
                <div class="vis-left">
                    <div class="part-img">
                        
                        <el-image
                            v-if="epcImg"
                            :src="epcImg"
                            :preview-src-list="[epcImg]"    
                        ></el-image>

                    </div>      
                </div>
                <div class="vis-right">
                    <el-table
                        :data="moreScdPartList"
                        tooltip-effect="dark"
                       
                        @select="select"
                        @select-all="selectAll"
                    >
                        <el-table-column
                            v-if="moreScdPartList.length>1"
                            prop="check"
                            type="selection"
                            width="55"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="pots_number"
                            label="图号"
                            width="50"
                            show-overflow-tooltip
                        >
                        </el-table-column>
                        <el-table-column
                            prop="item_name"
                            label="配件名称"
                            show-overflow-tooltip
                        >
                        </el-table-column>
                        <el-table-column
                            prop="part_number"
                            label="OE"
                            width="120"
                            show-overflow-tooltip
                        >
                        </el-table-column>
                        <el-table-column
                            prop="part_name"
                            label="原厂名称"
                            show-overflow-tooltip
                        >
                        </el-table-column>
                        <el-table-column
                            prop="price_4s"
                            label="4S价格"
                            width="120"
                            show-overflow-tooltip
                        >
                        </el-table-column>
                        <el-table-column
                            prop="part_memo"
                            label="备注 "
                            show-overflow-tooltip
                        >
                        </el-table-column>
                    </el-table>
                </div>   
            </div>

            <div slot="footer" class="dialog-footer" v-if="moreScdPartList.length>1" >
                <el-button size="small" @click="moreScdVis = false">取 消</el-button>
                <el-button size="small" type="primary" @click="seleInsetList">确定</el-button>
            </div>
		</el-dialog>

        <el-dialog title="历史购买记录" :visible.sync="hisVis" center  width="800px">
            <div class="his-list">
                <div class="list-head">
                    <div>购买时间</div>
                    <div>发货时间</div>
                    <div>购买人</div>
                    <div class="col-100">价格</div>
                    <div class="col-100">购买个数</div>
                    <!-- <div class="col-100">发货个数</div> -->
                    <div class="col-100">订单状态</div>
                </div>
                <div class="list-body">
                    <div class="row" v-for="(his,index) in gooodsHisList" :key="index">
                        <div>{{$hnwTools.formatDateTime(his.add_time,'ymd')}}</div>
                        <div>{{$hnwTools.formatDateTime(his.delay_time,'ymd')||"无"}}</div>
                        <div>{{his.member_name}}</div>
                        <div  class="col-100">{{his.goods_price}}</div>
                        <div  class="col-100">{{his.goods_num}}</div>
                        <!-- <div  class="col-100">{{his.send_num?his.send_num:'0'}}</div> -->
                        <div class="col-100">{{$hnwTools.getOrderStateText(his.order_state)}}</div>
                    </div>
                </div>

            </div>
        </el-dialog>
    </div>
    
    <el-drawer
            title="我是标题"
            :visible.sync="drawerVis"
            :with-header="false"
            direction="btt"
            size="80%"
            :destroy-on-close="true"
        >
        <VInTree :propVin="vinCode" :brandList="vehBrandList" @seleTreePart="seleTreePart"></VInTree>
    </el-drawer>

    <el-drawer
        :visible.sync="partDrawerVis"
        :with-header="false"
        direction="btt"
        size="50%"
        :modal="false"
        >
        <!-- :style="{'height':infoProportion +'px'}" -->
        <div class="vin-part-info" id="partInfo"  >
            <div class="info-type-list">
                <div class="type-item" :class="{'active':infoModuType==item.type}" v-for="(item,index) in infoTypeList" :key="index" @click="handleClick(item.type)">
                    <div>
                        {{item.title}}
                    </div>
                </div>
                
            </div>
            <div v-loading="partInfoLoading">
                <template v-if="infoModuType=='pirce'">
                    <div class="mode-body price-list">
                        <div class="list-head">
                            
                            <div class="index-num">#</div>
                            <div>车厂</div>
                            <div>原厂编码</div>
                            <div>采购价(不含税)</div>
                            <div>采购价(含税)</div>
                            <div>销售价(不含税)</div>
                            <div>销售价(含税)</div>
                            <!-- <div>销售价(含税)</div> -->
                        
                        </div>
                        <div class="list-body">
        
                            <div class="list-row" v-for="(priceItem,index) in priceList" :key="index">
                                
                                <div class="index-num">{{index+1}}</div>
                                <div>{{priceItem.brand_name}}</div>
                                <div>{{priceItem.brand_part_number}}</div>
                                <div>{{priceItem.purchase_price}}</div>
                                <div>{{priceItem.purchase_price_tax}}</div>
                                <div>{{priceItem.sale_price}}</div>
                                <div>{{priceItem.sale_price_tax}}</div>
                                
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else-if="infoModuType=='link'">
                    <div class="mode-body link-list">
                        <div class="list-head">
                            <div class="index-num">#</div>
                            <div class="cc-brand">车厂品牌</div>
                            <div class="code">替换码</div>
                            <div class="price">采购价</div>
                            <div class="price">销售价</div>
                            <div>备注</div>
                        
                            <div class="handle">操作</div>
                        </div>
                    
                        <div class="list-body">
                            <div class="list-row" v-for="(replace,index) in replaceList" :key="index">
                                <div class="index-num">{{index+1}}</div>
                                <div class="cc-brand">{{replace.brand_name}}</div>
                                <div class="code">{{replace.replace_number}}</div>
                                <div class="price">{{replace.purchase_price}}</div>
                                <div class="price">{{replace.sale_price}}</div>
                                <div>{{replace.remark}}</div>
                                
                                <div class="handle" >
                                    <i class="el-icon-shopping-cart-2"  @click="toBuy(replace)" v-if="replace.gysNum&&$store.getters.notLvD"></i>
                                </div>
                            </div>
                        </div>
        
                    </div>
                </template>
                <template v-else-if="infoModuType=='veh'">
                    <div class="mode-body veh-list">
                        <div class="list-head">
                            <div class="index-num">#</div>
                            <div>品牌名称</div>
                            <div>年款</div>
                            <div>车系名称</div>
                            <div class="veh-mune-name">车型目录名称</div>
                            <div>配件编码</div>
                            <!-- <div class="handle" v-if="queryType=='part'">操作</div>             -->
                        </div>
        
                        <div class="list-body" >
                            <div class="list-row" v-for="(veh,index) in vehList" :key="index">
                                <div class="index-num">{{index+1}}</div>
                                <div>{{veh.brand_name}}</div>
                                <div>{{veh.production_year}}</div>
                                <div>{{veh.car_series_name}}</div>
                                <div class="veh-mune-name" :title="veh.series_name">{{veh.series_name}}</div>
                                <div>{{veh.part_number}}</div>
                                <!-- <div class="handle" v-if="queryType=='part'">
                                    <span class="btn" @click="readVehInfo(veh)">查看</span>
                                </div> -->
                            </div>
                        </div>
                        
                    </div>
                </template>
                <template v-else-if="infoModuType=='store'">
                    <div class="store-msg"  >
                        <div class="mode-body store-list">
                            <div class="list-head">
                                <div class="index-num">#</div>
                                <div>是否互换件</div>
                                <div>名称</div>
                                <div>OE号</div>
                                <div>生产编码</div>
                                <div>品牌</div>
                                <div>价格</div>
                                <div>库存</div>
                                <div class="handle">操作</div>
                            </div>
                            <div class="list-body" >
                                <div class="list-row" v-for="(goods,index) in storeList" :key="index">
                                    <!-- <div>{{goods.store_name}}</div> -->
                                    <!-- 简称 -->
                                    <div class="index-num">{{index+1}}</div>
                                    <div>
                                        {{ goods.isHhj?"是":"否" }}
                                    </div>
                                    <div>{{goods.goods_name}}</div>
                                    <div>{{goods.oecode}}</div>
                                    <div>{{goods.sccode}}</div>
                                    <div>{{goods.oenaturebrand}}</div>
                                    <div v-if="$store.state.shop==1948">详询销售</div>
                                    <div v-else>{{goods.goods_price}}</div>
                                    <div>
                                        <span v-if="$store.state.look_inv==1">{{goods.goods_storage}}</span>
                                        <span v-else-if="$store.state.shop==1948">有货</span>
                                        <span v-else>{{goods.goods_storage>0?"有货":"无货"}}</span>
                                    </div>
                                    <div class="handle" v-if="$store.state.shop==1948">
                                        <span  class="btn" @click="joinCart(goods)"> 
                                            加入购物车 
                                        </span>
                                    </div>
                                    <div class="handle" v-else>
                                        <span class="btn" :class="{'ygd':goods.goods_storage==0}" @click="joinCart(goods)">
                                            {{goods.goods_storage>0?'加入购物车':'加入预购单'}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    
                    </div>
                </template>
                <template v-else-if="infoModuType=='sonPart'">
                    <div class="mode-body price-list">
                        <div class="list-head">
                            <div class="index-num">#</div>
                            <div class="factory">车厂</div>
                            <div>配件编码</div>
                            <div>配件名称</div>
                            <div>备注</div>
                            <div>采购价格(不含税)</div>
                            <div>采购价格(含税)</div>
                            <div>销售价(未含税)</div>
                            <div>销售价(含税)</div>
                            
                        </div>
                        <div class="list-body" >
                            
                            <div class="list-row" v-for="(priceItem,index) in kitrList" :key="index">
                                <div class="index-num">{{index+1}}</div>
                                <div class="factory">{{priceItem.brand_name}}</div>
                                <div>{{priceItem.part_number}}</div>
                                <div>{{priceItem.part_name}}</div>
                                <div>{{priceItem.remark}}</div>
                                <div>{{priceItem.purchase_price}}</div>
                                <div>{{priceItem.purchase_price_tax}}</div>
                                <div>{{priceItem.sale_price}}</div>
                                <div>{{priceItem.sale_price_tax}}</div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else-if="infoModuType=='partImg'">
                    <div class="mode-body part-img-list" >
                        <div class="img-box" v-for="(img,index) in partImgList" :key="index">
                            <!-- <img :src="img" alt="" @click="redBigImg(img)" srcset=""> -->
                            <el-image
                                :src="img"
                                :preview-src-list="[img]"    
                            ></el-image>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </el-drawer>

    <el-dialog title="配件表格" :visible.sync="exVis" custom-class="ex-dia" width="1000px">
        <div id="exList-box">
            <div class="ex-table-row ex-row">车架号:{{ vinCode }}</div>
            <div class="ex-table-row ex-row">{{ carInfo.vehicle_show_name }}</div>
            <el-table :data="exList" row-class-name="ex-table-row" border header-row-class-name="ex-table-row">
                <el-table-column property="title" label="需求项" ></el-table-column>
                <!-- <el-table-column property="part_group_name" label="译码名称" ></el-table-column> -->
                <el-table-column property="part_number" label="原厂OE" ></el-table-column>
                <el-table-column property="goods_name" label="配件名称" ></el-table-column>
                <el-table-column property="bj_price" label="输入报价"  width="110">
                    <template #default="scope">
                            <el-input size="mini" placeholder="输入报价" v-model="scope.row.bj_price" ></el-input>
                    </template>
                </el-table-column>
                
                <el-table-column property="oecode" label="OE" ></el-table-column>
                <el-table-column property="sccode" label="生产码" ></el-table-column>
                <el-table-column property="oenaturebrand" label="品牌"  width="80"></el-table-column>
                <el-table-column property="vehicletype" label="适配车型" width="160"></el-table-column>
                <el-table-column property="goods_price" label="价格"  width="80"></el-table-column>
                
            </el-table>
            <!-- <div class="ex-table-row row-total ex-row">总计 {{ demaPrice }}</div> -->
        </div>

        <span slot="footer" class="dia-footer">
            <el-button type="primary" size="mini" @click="downXlsl">下载表格</el-button>
            <el-button type="primary" size="mini" @click="convertTableToImage">保存图片</el-button>
        </span>
    </el-dialog>

</div>
</template>
<script>
// 火花塞 大灯 雨刮
import VInTree from "../epcWeb/VInTree.vue"
import { export_json_to_excel } from "../../common/utils/Export2Excel.js"
import html2canvas from 'html2canvas';
export default {
    data(){
        return{

            Vindata:{
                member_id:this.$store.state.member_id,
                shop_id:this.$store.state.shop,
                member_name:this.$store.state.member_name,
                store_name:this.$store.state.store_name
            },
            vehBrandList:"",
            // 变速箱油,牛腿,火花塞,乐基,   前下臂  变速箱油 火花塞,牛腿,乐基,前下臂
            // 02E911024M,038906051P,03F907660E,06B906036D,06H109469AD,06H109469AE,火花塞,牛腿
            // 02E911024M,038906051P,03F907660E,06B906036D,06H109469AD,06H109469AE,
            partNames:"",
            // ,火花塞,牛腿,乐基,前下臂,牛腿 
            
            demandList:[],
            spanMap: [],
            demaLoading:false,
            vinCode:"",
            manufacturer_id:"12",
            exList:[],
            exVis:false,
            carInfo:{
            },
            vinHisList:[],
            moreScdVis:false,
            canClick:true,
            drawerVis:false,
            partDrawerVis:false,
            // {
            //     title:"供应商",
            //     type:"store"
            // },
            infoTypeList:[
                
                {
                    title:"4S参考价",
                    type:"pirce"
                },
                {
                    title:"通用替换件",
                    type:"link"
                },
                {
                    title:"适用车型",
                    type:"veh"
                },
                {
                    title:"子配件",
                    type:"sonPart"
                },
                {
                    title:"配件实物图",
                    type:"partImg"
                },
            ],
            moreScdPartList:[],
            epcImg:"",
            gooodsHisList:[],
            hisVis:false,
            carAllMsg:"",
            carMsgfilterText:"",
            activeMsgTag:"main",
            viewportH:"0",
            infoProportion:0,
            partInfoLoading:false,
            infoModuType:"pirce",
            priceList:[],
            replaceList:[],
            vehList:[],
            storeList:[],
            kitrList:[],
            partImgList:[],
            titleColorMap: {},
            // 可选的颜色列表
            colorPalette: ['#fff',  '#E8F1FF'],
            currentColorIndex: 0,
            demaPrice:""
        }
    },
    methods:{
        reset(){
            this.carInfo = {}
            this.carAllMsg = []
            this.mainGroupList = []
            this.branchGroupList = []
            this.carMsgfilterText = ""
            this.imgList = []
            this.partInfo = {

            }
        },
        
        deleteRow(index, rows,row,type) {
            if(type=='1'){
                
                rows.splice(index, row.children?row.children.length+1:1); 
                
            }else{
                
                // children  也要删
                
                
                if(!row.isChild){
                    let children = [...row.children]
                    rows.splice(index, 1);
                    let obj = rows.find(item=>item.title==row.title&&item.isChild)
                    obj.isChild = false
                    obj.cIndex = 0
                    children.pop()
                    obj.children = children
                    
                }else{
                    rows.splice(index, 1); 
                    
                    let obj = rows.find(item=>item.title==row.title)
                    if(obj.children.length>=row.cIndex){
                         obj.children.pop()
                    }else{
                        obj.children.splice(row.cIndex||0, 1)
                    }

                }

            }
            // this.demandList = rows
        },
        partRowClick(e,i){
            // e 
            this.getEpcImg(e)
        },
        demandRowClick(e,i){
            
            this.infoModuType=="pirce"
            // this.getEpcImg(e.part_number)
            this.partDrawerVis = true
            this.demandInfo = e;
            this.handleClick()
        },
        async getEpcImg(partInfo){
            
            let posRes = await this.$apiScd.getImgPos({
                fac_number:this.manufacturer_id,
                series_number:this.carInfo.series_id,
                ...partInfo
            })
            let imgInfo = posRes[0]
           
            this.drawCircleOnImage(imgInfo) 

            // this.epcImg = imgInfo.image_url  

        },

        async getCarInfoByVIn(){

            // 再解析车辆详情
            let info = await this.$apiScd.getVinInfo({
                vin:this.vinCode,
                manufacturer_id:this.manufacturer_id
            })
            this.carAllMsg = info || []
            // 获取主组
            // this.getMainGroup()
            
            await this.$api.addSearchRecord({
                record_name:this.vinCode,
                record_type:3,
                car_type:this.carInfo.vehicle_full_name,
                record_from:1
            })
        },
        // 选中行
        async drawCircleOnImage(imgInfo) {
            const img = new Image();
            img.crossOrigin = 'Anonymous'; // 如果图片来自不同域，必须设置跨域
            // 返回 Promise，等待图片加载完成
            const loadImage = (url) => {
                return new Promise((resolve, reject) => {
                    img.onload = () => resolve(img);
                    img.onerror = (e) => reject(e);
                    img.src = url;
                });
            };
            
            try {
                //   https://test.huanuowei.cn
                
                // let imgUrl = imgInfo.image_url.replace("https://pic.car1000.com","https://huanuowei.cn/agent-car1000")
                // let imgUrl = imgInfo.image_url.replace("https://www.car1000.com","https://huanuowei.cn/agent-car1000")
                let imgUrl = ""
                let replaStrat = window.location.hostname.startsWith('www.')?'https://www.':"https://";
				imgUrl = imgInfo.image_url.replace("https://pic.car1000.com",replaStrat+"huanuowei.cn/agent-car1000")
				imgUrl = imgUrl.replace("https://www.car1000.com",replaStrat+"huanuowei.cn/agent-car1000")
				imgUrl = imgInfo.image_url.replace("https://www.tenlanes.cn",replaStrat+"huanuowei.cn/agent-car1000")
				imgUrl = imgUrl.replace("https://tenlanes.cn/",replaStrat+"huanuowei.cn/agent-car1000")
                // imgInfo.image_url
                const image = await loadImage(imgUrl);
                console.log("imgUrl",imgUrl);
                
                // 创建 canvas
                const canvas = document.createElement('canvas');
                
                const ctx = canvas.getContext('2d');
                
                // 设置 canvas 尺寸与图片一致
                
                canvas.width = image.width;
                
                canvas.height = image.height;
                
                // 绘制原始图片
                ctx.drawImage(image, 0, 0);
                let dot = {}
                dot.x = imgInfo.pots_x1
                dot.y = imgInfo.pots_y1
                dot.w = imgInfo.pots_x2 -  imgInfo.pots_x1
                dot.h = imgInfo.pots_y2 -  imgInfo.pots_y1


                
                // 绘制圆形红点
                ctx.beginPath();

                ctx.arc(dot.x,dot.y, dot.w, 0, Math.PI * 2);
                
                ctx.fillStyle = 'red';
                ctx.fill();
                // 在圆点中心绘制数字
                // ctx.font = "bold    20px '字体','字体','微软雅黑','宋体'"; //设置字体
                // ctx.textBaseline = 'middle'; //在绘制文本时使用的当前文本基线
                // ctx.fillStyle="#fff";  //设置笔触的颜色
                // ctx.fillText(imgInfo.pots_number,Number(dot.x)+12,Number(dot.y)+25);
                
                this.epcImg = canvas.toDataURL('image/png');
                // 或者返回 base64 数据用于上传等用途
                // console.log(canvas.toDataURL('image/png'));

            } catch (error) {
                console.error('图片加载失败:', error);
            }
        },
        exportPart(){

        },

        // 生成
        async showGoodsList() {
           this.demaPrice = 0
           
           this.exList = this.demandList.map(item=>{
               if(item.goodsInfo){
                   this.demaPrice += Number(item.goodsInfo.goods_price)
               }
               return {
                    title:item.title,
                    part_group_name:item.partInfo.part_group_name,
                    part_number:item.partInfo.part_number,
                    goods_name:item.goodsInfo?item.goodsInfo.goods_name:"",
                    oecode:(item.goodsInfo?item.goodsInfo.oecode:"")+(item.goodsInfo&&item.goodsInfo.isPep?'(互)':''),
                    sccode:item.goodsInfo?item.goodsInfo.sccode:"",
                    oenaturebrand:item.goodsInfo?item.goodsInfo.oenaturebrand:"",
                    goods_price:item.goodsInfo?item.goodsInfo.goods_price:"",
                    bj_price:"",
                    vehicletype:item.goodsInfo?item.goodsInfo.vehicletype:""
                }
           })
           
           this.exVis = true
        },
        async convertTableToImage() {
            
            const table = document.querySelector('#exList-box');
            const canvas = await html2canvas(table);

            const imgData = canvas.toDataURL('image/png');
            this.copyImageToClipboard(imgData);

        },
        copyImageToClipboard(imgData) {
            const link = document.createElement('a');
            link.href = imgData;
            link.download = '译码配件.png';
            link.click();
        },
        downXlsl(){
            let list = this.exList
            
            // 表头

            let tHeader = [
                "需求项",
                "原厂OE",
                "配件名称",
                "报价",
                "OE",
                "生产码",
                "品牌",
                "适配车型",
                "价格",
            ]
            // 哪些字段
            let filterVal = [
                "title",
                "part_number",
                "goods_name",
                "bj_price",
                "oecode",
                "sccode",
                "oenaturebrand",
                "vehicletype",
                "goods_price",
            ]
            
            let data = this.formatJson(filterVal,list)
            
            export_json_to_excel({
                header:tHeader,
                data,
                filename:"智能译码",
                autoWidth:true,
                bookType:'xlsx'
            })
        },
        formatJson(filterVal, tableData) {
            return tableData.map(v => {
                return filterVal.map(j => {
                        return v[j]
                    })
                }
            )
        },
        async vinSearch(type){
            // console.log("查询vin");
            // if(this.$store.state.store_id!=1780&&this.$store.state.store_id!=1989&&this.$store.state.store_id!=1974&&this.$store.state.store_id!=2223&&this.$store.state.store_id!=1871){
            //     return this.$warMsg("暂未开放")
            // }
            if(!this.canClick){
                return console.log("重复点击")
            }
            this.demandList = []
            this.vinCode = this.vinCode.replace(/\s/g,'').toUpperCase()
            if(!this.$store.state.vinTotal){
                await this.$store.dispatch("getVinNum")
            }
            if(this.vinCode.length!=17){
                return this.$warMsg("车架号长度必须17位，请检查您的车架号")
            }
            
            this.vinCode = this.vinCode.replace(/O/g,'0')
            this.vinCode = this.vinCode.replace(/I/g,'1')
            this.vinCode = this.vinCode.replace(/Q/g,'9')

            this.canClick = false
            // 次数用完 不论是否查询过都不可查询 2021-11-27
            if(this.$store.state.vinNum<1&&this.$store.state.store_id!=1989){
                this.$warMsg("您的次数已用完")
                return false
            }

            
            this.treeLoading = true
            // 查询是否扣费
            // 清除信息
            this.reset()
            let feeRes = await this.$api.getFeeSite(1)
           
            
            let ins_ok = 1
            // 永不扣费
            if(feeRes.ins_ok==0){
                ins_ok = 0

            }else if(feeRes.ins_repeat_ok==0){
               
                let searTime = await this.$api.getSearTime({
                    record_name:this.vinCode,
                    store_id:this.$store.state.store_id
                
                })
                
                if(Array.isArray(searTime)){
                    console.log("未找搜索记录，扣费")
                    
                }else{

                    if(Number(feeRes.ins_date)==0){
                        ins_ok = 0
                        console.log("永久不扣费")
                    }else{
                        // 当前时间是
                        let nowTime = new Date().getTime()/1000
                        // 扣费周期

                        let feeDate = Number(feeRes.ins_date)*60*60*24 
                        
                        if(nowTime - searTime.add_time > feeDate){
                            ins_ok = 1
                            console.log("超出免费周期，扣费");
                        }else{
                            ins_ok = 0
                        }
                    }
                    
                }
            }
            
        
           
            
           
            this.demaLoading = true

            let item_name = []
            
            if(this.partNames.includes(",")){
                this.partNames = this.partNames.replace(/\s/g, '')
                item_name = this.partNames.split(",") || []
            }else if(this.partNames.includes("，")){
                this.partNames = this.partNames.replace(/\s/g, '')
                item_name = this.partNames.split("，") || []
            }else if(this.partNames.includes("\n")){
                this.partNames = this.partNames.replaceAll(",","")
                this.partNames = this.partNames.replaceAll("，","")
                item_name = this.partNames.split("\n") || []
            }else if(this.partNames){
                item_name = [this.partNames]
            }
            try {
                item_name = item_name.map(item=>item.trim())
                item_name = item_name.filter(item=>item)
            } catch (error) {
                
            }
            
            
            let res = await this.$apiScd.hnwGetPartsbyVinName({
                vin:this.vinCode,
                item_name:item_name.join(",")||"",
                store_id:this.$store.state.store_id,
                store_name:this.$store.state.store_name,
                member_id:this.$store.state.member_id,
                member_name:this.$store.state.member_name,
            })
            location.href = location.href.split("#")[0]+`#/finByVin/${this.vinCode}`
            let demandList = []
          
            item_name.forEach(item=>{
                if(item){
                    
                    demandList.push({
                        title:item.trim(),
                        part_name:item.trim(),
                        partList:[],
                    })
                }
            })
            
            this.getPartListByVin(res,demandList,ins_ok,type)           
            this.canClick = true
            this.$store.dispatch("getVinNum")
        },
        async getPartListByVin(res,demandList,ins_ok,type){
            
            console.log("res",res);
            // if(res.code==500){
            //     this.$warMsg(res.message)
            //     return this.demaLoading = false
            // }

            if(!res){
                // this.$warMsg("暂无结果")

                return this.demaLoading = false
            }
            if(res.content){
                res = res.content
            }
            if(res.vin_info){

                this.$api.addUseHis({
                    use_model:"快速译码解析",
                    use_content:this.vinCode,
                    is_ok:ins_ok,
                    store_id:this.$store.state.store_id,
                    store_name:this.$store.state.store_name,
                    member_id:this.$store.state.member_id,
                    member_name:this.$store.state.member_name,

                })
                
                this.carInfo = res.vin_info[0]

                this.manufacturer_id = this.carInfo.manufacturer_id
                res.decode_infos = res.decode_infos?res.decode_infos:[]
                res.decode_infos = res.decode_infos.filter(item => item.lock_flag == 1||item.lock_flag == 2||item.lock_flag == null )
               
                let oeList = res.decode_infos.map(item => item.part_number)
                let searOes =""
                
                // 处理oe啥的
                // const searOeList = demandList.filter(demandItem => 
                //     demandItem.title&&demandItem.title.length>4&&!res.decode_infos.some(info => info.item_name === demandItem.title)
                // )
                
                // let searOes = searOeList.map(item=>{
                //     item.isOe = true
                //     return item.title
                // }).join()
                // + "," + searOes
                // console.log("不包含的OE",searOes);
                

                oeList = [...new Set(oeList)];
                let hnwGoodsRes = await this.$api.getGoodsByOes({
                    oecode: oeList.join(",") ,
                    for_branch: this.$store.state.for_branch
                });

                // 所有配件列表
                let goodsList = [];
                let addGoods_id = ""
                
                if (hnwGoodsRes.db) {
                    hnwGoodsRes.db.forEach((goods) => {
                        this.$set(goods, "isPep", false);
                        addGoods_id += goods.goods_id + ","
                    });
                    goodsList = [...hnwGoodsRes.db];
                }
                
                
                
                if (hnwGoodsRes.data) {
                    // 互换件项
                    hnwGoodsRes.data.forEach((exInfo) => {
                        if(exInfo.exchange&&exInfo.exchange.length>0){
                            
                            let mainGoods  = goodsList.find(goods=>goods.oecode==exInfo.oecode)
                            exInfo.exchange.forEach(goods=>{
                                if(!addGoods_id.includes(goods.goods_id)){
                                    this.$set(goods, "isPep", true);
                                    this.$set(goods, "replaces", exInfo.oecode);
                                    if(mainGoods){
                                        if(mainGoods.goods_id!=goods.goods_id){
                                            goodsList.push(goods)
                                        }
                                    }else{
                                        
                                        goodsList.push(goods)
                                    }
                                    addGoods_id += goods.goods_id + ","
                                }
                            })
                        }
                    });
                    
                }
                
                
                let goods_id = ""
                
                goodsList.forEach((goods) => {
                    this.$set(goods, "goods_num", 1);
                    goods.goods_price =  this.$handlePrice(goods);
                    // 华诺威展示丹阳库存
                    
                    if(this.$store.state.store_id=='1780'){
                         goods.goods_storage = goods.goods_stcids
                    }
                    goods_id += goods.goods_id + ","
                })
                
                let res1 = await this.$api.getGoodsRecord(goods_id);
                
                goodsList.forEach((goods) => {
                    goods.buyHisList =  res1.filter(item=>item.goods_id==goods.goods_id) || []
                })

                demandList.forEach((demandItem)=>{
                    
                    // 如果不是展开的子元素
                    demandItem.partList = res.decode_infos.filter(item=>demandItem.title==item.item_name) 
                    if(demandItem.partList.length==0){
                        
                        demandItem.partInfo = {}
                        if(demandItem.isOe){
                            // oe号
                            let children = []
                            
                            demandItem.partInfo.part_number = demandItem.title
                            // 处理华诺威配件
                            try {
                                
                                let partGoodsList = goodsList.filter(goods=>goods.oecode==demandItem.title) || []
    
                                let partRplaceList = goodsList.filter(goods=>{
                                    if(goods.isPep){
                                        
                                       return goods.replaces&&goods.replaces.includes(demandItem.title)
                                    }else{
                                        return false
                                    }
                                })

                                let partAllGoodsList = [...partGoodsList,...partRplaceList]

                                if(partAllGoodsList.length>0){
                                    demandItem.partInfo.goodsInfo = partAllGoodsList[0]
                                }
                                
                                // 如果没找到配件 会替换掉第一个
                                partAllGoodsList.forEach((hnwGoods,goodsIndex)=>{
                                    if(goodsIndex==0){
                                        this.$set(demandItem,"partInfo",demandItem.partInfo)
                                        this.$set(demandItem,"goodsInfo",hnwGoods)
                                    }else{
                                        children.push({
                                            ...demandItem,
                                            partInfo:demandItem.partInfo,
                                            isChild:true,
                                            
                                            goodsInfo:hnwGoods
                                        })
                                    }
                                })
                               
                            } catch (error) {
                                console.log("err",error);
        
                            }
                            demandItem.children = children
                        }else{
                            demandItem.isHand = true
                        }
                    }else{
                        // 直接展开
                        let children = []
                        let cIndex = 0
                        // 循环拾车道列表
                        demandItem.partList.forEach(async (part,partIndex)=>{
                            
                            // 处理华诺威配件
                            try {
                                if(part){
                                    let partGoodsList = goodsList.filter(goods=>goods.oecode==part.part_number) || []
        
                                    let partRplaceList = goodsList.filter(goods=>{
                                        if(goods.isPep){
                                            
                                           return goods.replaces&&goods.replaces.includes(part.part_number)
                                        }else{
                                            return false
                                        }
                                    })

                                    let partAllGoodsList = [...partGoodsList,...partRplaceList]
                                    if(partAllGoodsList.length>0){
                                        part.goodsInfo = partAllGoodsList[0]
                                    }
                                    // 如果没找到配件 会替换掉第一个
                                    if(partAllGoodsList.length==0){
                                        if(partIndex==0){
                                            this.$set(demandItem,"partInfo",part)
                                            this.$set(demandItem,"goodsInfo",'')
                                            this.$set(demandItem,"cIndex",cIndex)
                                            
                                        }else{
                                            
                                            children.push({
                                                ...demandItem,
                                                partInfo:part,
                                                isChild:true,
                                                goodsInfo:"",
                                                cIndex
                                            })
                                        }
                                        
                                        cIndex++
                                    }else{
                                        
                                        partAllGoodsList.forEach((hnwGoods,goodsIndex)=>{
                                            if(partIndex==0&&goodsIndex==0){
                                                this.$set(demandItem,"partInfo",part)
                                                this.$set(demandItem,"goodsInfo",hnwGoods)
                                                this.$set(demandItem,"cIndex",cIndex)
                                            }else{
                                                children.push({
                                                    ...demandItem,
                                                    partInfo:part,
                                                    isChild:true,
                                                    cIndex,
                                                    goodsInfo:hnwGoods
                                                })
                                            }
                                            cIndex++
            
                                        })
                                    }
                                }
                                
                            } catch (error) {
                                console.log("err",error);
                                
                            }

                            // 处理展开
                            
                        })

                        demandItem.children = children
                    }

                })

                // console.log("demandItem.partList",demandItem.partList)

            }else{
                demandList = []
                this.carInfo = {}
                this.$api.addUseHis({
                    use_model:"快速译码解析(查询失败)",
                    use_content:this.vinCode,
                    is_ok:0,
                    store_id:this.$store.state.store_id,
                    store_name:this.$store.state.store_name,
                    member_id:this.$store.state.member_id,
                    member_name:this.$store.state.member_name,
                })
                this.$warMsg("查询失败")
            }
            this.demandList = this.flattenData(demandList)
            this.demandList.forEach(demandItem=>{
                if(demandItem.goodsInfo){
                    this.addAlias(demandItem.goodsInfo,demandItem.title)
                    this.addAlias(demandItem.goodsInfo,demandItem.partInfo.part_group_name)
                }
            })
            this.demaLoading = false
            // this.partList = goodsList
            // 获取配置详情
            this.getCarInfoByVIn()
        },
        flattenData(data) {
            const result = [];
            data.forEach(item => {
                // 先添加当前项
                result.push(item);
                // 如果有 children，就依次插入到当前项之后
                if (item.children && item.children.length > 0) {
                    
                    result.push(...item.children);
                }
            });
            
            return result;
        },
        async addAlias(goods,alias){
      
            
            let res = await this.$api.addAlias({ 
                shop_id:this.$store.state.shop,
                buyer_id:this.$store.state.buyer_id,
                buyer_name:this.$store.state.store_name,
                member_id:this.$store.state.member_id,
                member_name:this.$store.state.nickname,
                goods_id:goods.goods_id,
                goods_name:goods.goods_name,
                data:alias,
                type:"insert"
            }) 
           
        },
        showPartList(demand){
            this.moreScdVis = true
            this.demandInfo = demand
            this.moreScdPartList = demand.partList
        },
        readHisList(goods){
            this.gooodsHisList = goods.buyHisList;
            this.hisVis = true;
        },
        copy(value){
           this.$copy(value)
            
        },
         // 通过电子目录查找
        toVinFind(demand){
            this.drawerVis = true
            this.demandInfo = demand
        },
        async readBoom(partInfo){
            
            this.moreScdVis = true
            this.getEpcImg(partInfo)

            this.moreScdPartList = [partInfo];
            // info.pots_number
        },
        select(data, row){
            row.check = !row.check;
        },
        selectAll(selection){
            // console.log("selection",selection);
            let checkAll = false
            if(selection.length>0){
                checkAll = true
            }
            this.moreScdPartList.forEach((item, index) => {
                item.check = checkAll
            })
        },
        seleInsetList(){
            let partList = this.moreScdPartList.filter(part=>part.check)
            let newList = []
            
            if(partList.length==0){
                return this.$warMsg("请选择配件")
            }else{

                partList.forEach((item,index)=>{
                    if(index==0){
                        this.$set(this.demandInfo,"partInfo",item)
                        this.$set(this.demandInfo,"goodsInfo",item.goodsInfo)
                    }else{
                        newList.push({
                            ...this.demandInfo,
                            partInfo:item,
                            isChild:true,
                            goodsInfo:item.goodsInfo
                        })
                    }
                })
            }

            // 查找最后一个 title == '牛腿' 的索引
            let lastIndex = -1;
            this.demandList.forEach((item, index) => {
                if (item.title === this.demandInfo.title) {
                    lastIndex = index;
                }
            })
            console.log("索引位置",lastIndex);
            
            // 如果找到了符合条件的项，在其后插入新数据
            if (lastIndex !== -1) {
                // 使用 splice 插入数据
                this.demandList.splice(lastIndex + 1, 0, ...newList);
            }

            this.moreScdVis = false


            
            // let info = this.moreScdPartList.find(part=>part.check)
            
            // if(info){

            //     this.$set(this.demandInfo,"partInfo",info)
            //     this.$set(this.demandInfo,"goodsInfo",info.goodsInfo)
                
            //     this.moreScdVis = false
            // }else{
            //     this.$warMsg("选择配件")
            // }

            // this.moreScdPartList = demand.partList
        },
        
        async seleTreePart(part){

            // let tempList = [...this.demandList]
            // this.demandList = []
            console.log("part",part);
            
            let hnwGoodsRes = await this.$api.getGoodsByOes({
                oecode: part.part_number,
                for_branch: this.$store.state.for_branch
            });
            
            // 所有配件列表
            let goodsList = [];
            
            let addGoods_id = ""
            if (hnwGoodsRes.db) {
                hnwGoodsRes.db.forEach((goods) => {
                    this.$set(goods, "isPep", false);
                    addGoods_id += goods.goods_id + ","
                });
                goodsList = [...hnwGoodsRes.db];
            }
            
            
            
            if (hnwGoodsRes.data) {
                // 互换件项
                hnwGoodsRes.data.forEach((exInfo) => {
                    if(exInfo.exchange&&exInfo.exchange.length>0){
                        
                        let mainGoods  = goodsList.find(goods=>goods.oecode==exInfo.oecode)
                        exInfo.exchange.forEach(goods=>{
                            if(!addGoods_id.includes(goods.goods_id)){
                                this.$set(goods, "isPep", true);
                                this.$set(goods, "replaces", exInfo.oecode);
                                if(mainGoods){
                                    if(mainGoods.goods_id!=goods.goods_id){
                                        goodsList.push(goods)
                                    }
                                }else{
                                    
                                    goodsList.push(goods)
                                }
                                addGoods_id += goods.goods_id + ","
                            }
                        })
                    }
                });
                
            }
            
            let goods_id = goodsList.map(goods=>goods.goods_id)
            let res1 = await this.$api.getGoodsRecord(goods_id);
            let newList = []
            if(goodsList.length==0){
                this.demandInfo.partInfo = part
            }else{
                goodsList.forEach((goods,index) => {
                    goods.buyHisList =  res1.filter(item=>item.goods_id==goods.goods_id) || []
                    this.$set(goods, "goods_num", 1);
                    goods.goods_price =  this.$handlePrice(goods);
                    // 华诺威展示丹阳库存
                    
                    if(this.$store.state.store_id=='1780'){
                         goods.goods_storage = goods.goods_stcids
                    }
                    newList.push({
                        ...this.demandInfo,
                        partInfo:part,
                        children:index==0?goodsList:'',
                        isChild:index!=0,
                        goodsInfo:goods
                    })
                })
    
                
                let lastIndex = -1;
                this.demandList.forEach((item, index) => {
                    if (item.title === this.demandInfo.title) {
                        lastIndex = index;
                    }
                })
                
                if (lastIndex !== -1) {
                    // 使用 splice 插入数据
                    this.demandList.splice(lastIndex +1, 0, ...newList);
                }

            }
           
            this.drawerVis = false

        },
        
        onSelectionChange(){

        },
        
        spanMethod({ row, column, rowIndex, columnIndex }) {
            
            if (columnIndex <2) {
                
                if(row.children&&!row.isChild&&row.children.length>0){
                    if(row.isHand){
                        return {
                            
                             rowspan: row.children.length,
                             colspan: 1
                         }; 

                    }else{

                        return {
                             rowspan: row.children.length+1,
                             // rowspan: row.children.length,
                             colspan: 1
                         }; 
                    }
                }else if(row.isChild){
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }else{
                    return {
                        rowspan: 1,
                        colspan: 1
                    };
                }
                
            }
        },
        spanExMethod({ row, column, rowIndex, columnIndex }){
            // if(rowIndex==0){
            //     return {
            //         rowspan: 1,
            //         colspan: 1
            //     };
            // }
            const rows = this.exList.length;
            const cols = 10; // 表格总列数

            // 合并第一行所有列
            if (rowIndex === 0) {
                if (columnIndex === 0) {
                return { rowspan: 1, colspan: cols };
                } else {
                return { rowspan: 0, colspan: 0 };
                }
            }

            // 合并第二行所有列
            if (rowIndex === 1) {
                if (columnIndex === 0) {
                return { rowspan: 1, colspan: cols };
                } else {
                return { rowspan: 0, colspan: 0 };
                }
            }

            // 合并最后一行所有列
            if (rowIndex === rows - 1) {
                if (columnIndex === 0) {
                return { rowspan: 1, colspan: cols };
                } else {
                return { rowspan: 0, colspan: 0 };
                }
            }

            // 默认不合并
            return {};
        },
        tableRowClassName({row, rowIndex}){
            
            if (rowIndex === 1) {
                return 'warning-row';
            } else if (rowIndex === 3) {
                return 'success-row';
            }
            return '';
        },
        getRowStyle({ row }) {
            const title = row.title;

            // 如果该 title 尚未分配颜色，则为其分配一个新颜色
            if (!this.titleColorMap[title]) {
                this.titleColorMap[title] = this.colorPalette[this.currentColorIndex % this.colorPalette.length];
                this.currentColorIndex++;
            }
            
            // 返回该行的样式
            return {
                backgroundColor: this.titleColorMap[title],
            };
        },
        getTitleSpanCount(data, index) {
            let count = 1;
            const currentTitle = data[index].title;

            for (let i = index + 1; i < data.length; i++) {
                if (data[i].title === currentTitle) {
                    count++;
                } else {
                    break;
                }
            }

            return count;
        },

        // 加入购物车
        impueNumChange(goods) {
          if (isNaN(goods.goods_num)) {
            this.$nextTick(() => {
              this.$set(goods, "goods_num", 1);
            });
          }
          if (goods.goods_storage > 0 && goods.goods_num > goods.goods_storage) {
            this.$nextTick(() => {
              goods.goods_num = goods.goods_storage;
            });
            return this.$store.commit("UpDateState", { invDia: true });
          }
        },
        joinCart(carItem) { 
          if(!carItem.goods_id){
            return 
          }
          const tidySubPart = async () => {
            let carMessage = {
              goods_id: carItem.goods_id,
              sccode: carItem.sccode,
              oecode: carItem.oecode,
              goods_name: carItem.goods_name,
              goods_price: carItem.goods_price,
              goods_num: carItem.goods_num,
              goods_storage: carItem.goods_storage,
              store_id: carItem.store_id,
              store_name: carItem.store_name,
              cart_type: "1"
            };

            let res =  await this.$api.joinCart([carMessage]);
            if(res){
              carItem.cartNum = Number(carItem.goods_num) + Number(carItem.cartNum)
            }
          };

          if (this.$isCompany()) {
            if(carItem.goods_storage>0){
              if(carItem.goods_num + Number(carItem.cartNum) >carItem.goods_storage){
                return this.$store.commit("UpDateState", { invDia: true });
              }else{
                tidySubPart();
              }
            }else{
              // 预购单提示
              if (carItem.goods_storage < 1 && Number(carItem.cartNum) > 0) {
                this.$affMsg("当前预购单已有该商品，是否继续添加?", tidySubPart);
              } else {
                tidySubPart();
              }
            }
          }
        },
        async joinCartAll() {
          let cart = [];

          if (this.storeGoodsList.length==0) {
            return this.$warMsg("没有任何商品");
          }
          this.storeGoodsList.forEach((goods) => {
            cart.push({
              goods_id: goods.goods_id,
              sccode: goods.sccode,
              oecode: goods.oecode,
              goods_name: goods.goods_name,
              goods_price: goods.goods_price,
              goods_num: goods.goods_num,
              goods_storage: goods.goods_storage,
              store_id: goods.store_id,
              store_name: goods.store_name,
              cart_type: "1",
             
            });
            
          });

          let res = await this.$api.joinCart(cart);
        },
        
        // 切换类型
        async handleClick(type) {
            this.partInfoLoading = true
            if(type){
                this.infoModuType = type
            } 
            if(this.demandInfo.partInfo.part_number){
                if(this.infoModuType=="pirce"){
                    // 获取价格
                    await this.getPrice()
                }else if(this.infoModuType=="link"){
                    // 获取替换件
                    await this.getPartReplace()
                }else if(this.infoModuType=="veh"){
                    // 获取适配车型
                    await this.getPartVeh()
                }else if(this.infoModuType=="store"){
                    await this.getStoreList()
                }else if(this.infoModuType=="sonPart"){
                    await this.getKitrList()
                }else if(this.infoModuType=="partImg"){
                    await this.getPartImage()
                }
            }
            this.partInfoLoading = false
            
        },
        async getPrice(){ 
            if(this.demandInfo.partInfo.part_number){
                let res = await this.$apiScd.getPartPrice({
                    manufacturer_id:this.manufacturer_id,
                    part_number:this.demandInfo.partInfo.part_number,
                })
                
                this.priceList = res.content 
            }
            
            // 根据二级车厂给出对应采购价
            // this.priceList.find(item=>item.)
        },
        async getPartReplace(){ 

            if(this.demandInfo.partInfo.part_number){
                let res = await this.$apiScd.getHnwPartReplace({
                    manufacturer_id:this.manufacturer_id,
                    part_number:this.demandInfo.partInfo.part_number
                })
                
                this.replaceList = res.content
                if(this.replaceList){
                    let pid_list = this.replaceList.map(item=>item.replace_number)
                    if(pid_list.length>0){
                        
                        let gysList = await this.$api.getGysNum({
                            oeList:pid_list,
                            for_branch:this.$store.state.for_branch,
                            shop:this.$store.state.shop
                        })
                        
                        gysList.forEach(item=>{
                            if(item.data.length>0){
                                this.replaceList.forEach(part=>{
                                    if(part.replace_number==item.oecode){
                                        part.gysNum = item.data.length
                                        part.storeList = item.data
                                    }
                                }) 
                            }
                            
                        })
                    }
                }
            }
             
        },
        async getPartVeh(){
            let res = await this.$apiScd.getPartVeh({
                manufacturer_id:this.manufacturer_id,
                part_number:this.demandInfo.partInfo.part_number
            })
            this.vehList = res
            this.brandList = []
        },
        async getStoreList(){
            let res = await this.$api.getDataCenterRepalce({
                oecode:this.demandInfo.partInfo.part_number
            })
            if(res){

                res = await this.$api.getBatchSearch({
                  oem:res.join()
                })
            }else{
                res = await this.$api.getBatchSearch({
                  oem:this.demandInfo.partInfo.part_number
                })
            }
          
            if(res&&res.length>0){
                res.forEach(goods=>{
                    goods.goods_price =  this.$handlePrice(goods)
                    this.$storageCangInfo(goods)
                    if(goods.oecode!=this.demandInfo.partInfo.part_number){
                        this.$set(goods,"isHhj",true)
                    }
                })
              this.storeList = res
            }else{
                this.storeList = []
            }
            
        },
        async getKitrList(){
            let res = await this.$apiScd.getPartKitr({
                manufacturer_id:this.manufacturer_id,
                part_number:this.demandInfo.partInfo.part_number
            })
            this.kitrList = res
        },
        async getPartImage(){
            let res = await this.$apiScd.getPartImage({
                manufacturer_id:this.manufacturer_id,
                part_number:this.demandInfo.partInfo.part_number
            })
           
            this.partImgList = res
        },
    },
    
    created(){
        
        this.viewportH = window.innerHeight - 150
        this.infoProportion = window.innerHeight - 250
        // if(this.$route.params.vin!='init'){
            
        //     this.vinCode =  this.$route.params.vin
        //     this.vinCode = this.vinCode.replace(/\s/g,'').toUpperCase()
            
        //     this.vinSearch()
            
        // }
        this.$store.dispatch("getVinNum")
        this.$nextTick(async ()=>{
            // 获取拾车道品牌列表
            let brandRes = await this.$apiScd.getAllBrand() 
            this.vehBrandList = brandRes 
        })
    },
    
    watch: {
        // immediate:true,
        // immediate:true,
        "$store.state.partVinCode": {
            deep: true,
            handler(n) {
                
                if(n.includes('old')){
                    this.vinCode =  n.replace("old","")
                }else{
                    this.vinCode =  n
                }
                this.vinCode = this.vinCode.replace(/\s/g,'').toUpperCase()
                if(this.vinCode){
                    this.vinSearch()
                }
            }
        }
        // async moreScdVis(n){

        //     let part_number = this.moreScdPartList[0].part_number
        //     this.getEpcImg(part_number)
            
        // }
    },
    
    components:{
        VInTree
    },
     computed: {
       
        showCarOtherMsg(){
            let list = this.carAllMsg.filter(item=>item.type==1)
            // console.log("list",list);
     
            return list.filter(item=>{
                if(item.value&&item.value.includes(this.carMsgfilterText)){
                    return true
                }else if(item.name&&item.name.includes(this.carMsgfilterText)){
                    return true
                }else{
                    return false
                }
            })

        },
    },
    props:{
        
    }
}
</script>

<style lang="scss">
.find-by-vin{
    background: #f9f9f9;
    .btn{
        cursor: pointer;
        background: #063376;
        padding: 2px 6px;
        color: #fff;
        margin-left: 2px;
    }
    .by-body{
        display: flex;
        flex-direction: column;
        background: #fff;
        padding: 15px;
    }
    .finvin-head{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .btn{
            width: 64px;
            text-align: center;
            height: 28px;
            line-height: 28px;
            margin-left: 4px;
        }
        .veh-info{
            display: flex;
            align-items: center;
            // padding: 5px 0;
            font-weight: 700;
            
            .ml-title{
                img{
                    width: 20px;
                    margin-right: 4px;
                }
            }
            .head-option{
                display: flex;
                align-items: center;
                margin-left: 10px;
                .red{
                    color: #FF1919;
                    margin-right: 5px;
                }
                span{
                    margin-left: 5px;
                }
            }
            .level-show-list{
                margin: 0 4px;
                background: #FBFBFB;
                border-radius: 2px;
                // height: 30px;
                padding: 10px 15px;
                margin-left: 10px;
                border: 1px solid #E8E8E8;
                font-family: Source Han Sans CN;
                font-weight: 400;
                font-size: 12px;
                color: #333333;
                max-width: 600px;
            }
            
        }
        .head-right{

        }
    }
    .result-body{
        flex: 1;
        padding: 10px 0;
        display: flex;
        .result-left{
            min-width: 200px;
            .btns{
                display: flex;
                align-items: center;
                padding: 5px 0;
                justify-content: space-between;
                .btn{
                    height: 32px;
                    line-height: 32px;
                    padding: 0 8px;
                }
            }
            .el-card{
                height: 100%;
                .el-card__header{
                    background: #FBFBFB;
                    padding: 10px;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                }
                .el-card__body{
                    padding: 15px;
                    border: 1px solid #EBEEF5;
                    .el-textarea__inner{
                        border: none;
                        padding: 0;
                        line-height: 26px;
                    }
                }
            }
        }
        
        .result-right{
            margin-left: 10px;
            .head-bold{
                .el-table__cell{
                    padding: 0;
                    >div{
                        background: #FBFBFB;
                        font-family: Source Han Sans CN;
                        font-weight: bold;
                        font-size: 14px;
                        height: 35px;
                        line-height: 35px;
                        color: #333333;
                    }
                }
            }
            .boom-img{
                // e
                width: 18px;
                margin-left: 4px;
                cursor: pointer;
            }

            .success-row {
                .el-table__cell{
                    background: #f0f9eb;
                }
            }
            .warning-row {
                .el-table__cell{
                    background: oldlace;
                }
            }
            
            .el-table__row{
                .el-table__cell{
                    // border-top: 2px solid #000;
                }

            }
            .cell{
                padding: 0 5px;
            }
            .el-table__cell{
                padding: 4px 0;
            }
            
            i{
                cursor: pointer;
                margin: 0 2px;

            }
            .el-icon-close{
                cursor: pointer;
            }
            .item-row{
                display: flex;
                align-items: center;
                // .label{
                //     white-space: nowrap;
                //     overflow: hidden;
                //     text-overflow: ellipsis;
                // }
                // .value{      
                //     white-space: nowrap;
                //     overflow: hidden;
                //     text-overflow: ellipsis;
                // }
            }
            .gg-row{
                .value{
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: 60px;
                }
            }
            .pp-row{
                .value{
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: 60px;
                    color: #063376;
                    font-weight: 700;
                }
            }

            .oe-row{

                .value{
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: 100px;
                }
            }
            .sc-row{
                .value{
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: 85px;
                }
            }
            .part-name{
                font-weight: bold;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .el-input-number{
                width: 100px;
            }
            // .goods-list{
            //     display: flex;
            // }
            .goods-item{
                display: flex;
                align-items: center;
                flex: 1;
                .info-left{
                    padding: 0 5px ;
                }
                .info-right{
                    flex: 1;
                    // padding-left: 5px;

                    .goods-name{
                        font-family: Source Han Sans CN;
                        font-weight: bold;
                        font-size: 12px;
                        color: #333333;
                        display: flex;
                        align-items: center;
                        justify-content:space-between;
                        position: relative;
                        .name-tag{
                            max-width: 164px;
                            display: flex;
                            align-items: center;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            .name-text{
                                max-width: 135px;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                            }
                            .tag-icon {
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                width: 20px;
                                height: 20px;
                                background: $vin-blue;
                                color: #fff;
                                border-radius: 50%;
                                font-size: 12px;
                                position: relative;
                                margin-left: 4px;
                                // 1
                                // left: 8px;
                            }
                        }
                        
                    }
                    .goods-row{
                        
                        display: flex;
                        align-items: center;
                        .label{
                            // min-width: 40px;
                            padding: 0 2px;
                        }
                        .item-row{
                            margin-right: 5px;
                        }
                        .vehicle-row{
                            .value{     
                                max-width: 200px;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                            }
                        }
                    }
                    .btns{
                        display: flex;
                        align-items: center;
                        .hand-btn{
                            cursor: pointer;
                            background: #e6efff;
                            border: 1px solid #063376;
                            color: #063376;
                            border-radius: 4px;
                            padding:0px 4px;
                            margin-left: 10px;
                            height: 24px;
                            line-height: 24px;
                        }
                    }
                }
            }
            .btn{
                width: 80px;
                height: 28px;
                
                background: rgba(6,51,118,0.1);
                border-radius: 4px;
                border: 1px solid #063376;
                color: #063376;
                font-family: Source Han Sans CN;
                font-weight: 400;
                font-size: 14px;
                text-align: center;
                line-height: 28px;
                cursor: pointer;
                padding: 0;
            }
            .add-btn{
                color: #F83431;
                border: 1px solid #F83431;
                background: #FEEBEA;
            }
        }
    }
    .el-dialog__header{
        padding: 10px;    
    }
    
    .el-dialog__body{
        padding: 10px;
        padding-top: 0;
        border-top: 1px solid #eee;
    }
    .el-dialog__footer{
        padding-bottom: 10px;
    }
    .ex-dia{
        div{
            color: #333;
        }
        #exList-box{
            padding: 10px;
            .el-input{
                border:1px solid #333;
            }
        }

        .el-table{
            border: 1px solid #333;
        }

        .ex-table-row{
            font-weight: 700;
            height: 30px;
            line-height: 30px;
            border: 1px solid #333;
            border-bottom: none;
            .el-table__cell{
                border-bottom: 1px solid #333;
                border-right: 1px solid #333;
                padding: 0;
                
                >div{

                }

                .el-input__inner{
                    border: none;
                    font-weight: 700;
                    color: #333;
                }

            }

        }
        .row-total{
            text-align: right;
            border-top: 0;
            border-bottom: 1px solid #333;
        }
        .ex-row{
            padding: 0 10px;
        }
        .el-dialog__body{
            padding: 0;
        }
        .el-dialog__footer{
            text-align: center;
            padding-top: 0;
        }
    }
    .part-vis-list{
        display: flex;

        .vis-left{
            min-width: 300px;
            width: 400px;
            .part-img{

            }
        }
        .vis-right{
            flex: 1;
        }
    }
    .his-list {
        .list-head {
            display: flex;
            height: 40px;
            align-items: center;
            background: #eeeeee;
            margin: 10px 0;
            padding: 0 8px;
            > div {
            flex: 1;
            text-align: center;
            }
            .col-100 {
            max-width: 100px;
            }
        }
        .list-body {
            .row {
            display: flex;
            padding: 0 8px;
            > div {
                flex: 1;
                padding: 2px 0;
                border-bottom: 1px solid #eee;
                flex: 1;
                text-align: center;
                line-height: 28px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .col-100 {
                max-width: 100px;
            }
            }
        }
    }
    
    .vin-part-info{
        
        overflow: hidden;
        
        background: #fff;
        width: 100%;
        bottom: 0;
        margin-top: 10px;
        border: 2px solid$scdLine;
        box-sizing: border-box;
        border-radius: 4px;
        position: relative;
      
        .el-tabs{
            .el-tabs__header{
                padding-left: 10px;
                margin: 0;
                .el-tabs__item{
                    height: 28px;
                    line-height: 28px;
                }
            }
        }
        .info-type-list{
            display: flex;
            padding-right: 10px;
            border-radius: 4px;
            position: relative;
            .type-item{
                padding: 0 5px;
                height: 28px;
                line-height: 28px;
                font-size: 16px;
                margin: 0 5px;
                background: #fff;
                cursor: pointer;
                border: 1px solid #b6c8e1;
                border-top: none;
                transform: skewX(15deg);
                >div{
                    transform: skewX(-15deg);
                }
            }
            .active{
                background: #36af47;
                color: #fff;
            }
            .add-pur-btn{
                position: absolute;
                right: 10px;
                top: 50%;
                transform: translateY(-50%);
                font-weight: 700;
                cursor: pointer;
                padding: 0 10px;
                height: 24px;
                line-height: 24px;
                text-align: center;
                background: #16b2ec;
                color: #fff;
                font-size: 16px;
                border-radius: 6px;
            }

        }

        .mode-body{
            height: 100%;
            .index-num{
                min-width: 40px;
                max-width: 40px;
            }
            .list-head{
                display: flex;
                height: 20px;
                align-items: center;
                // background: #FAFAFA;
                background: #FAFAFA;
                text-align: center;
                color: $scdTaCol;
                box-sizing: border-box;
                >div{
                    flex: 1;
                    border-right: 1px solid $scdLine;
                }
                >div:first-child{
                    // text-align: left;
                    // padding-left: 50px;
                }
                .factory{
                    width: 100px;
                }
            }
            .list-body{
                overflow: auto;
                // max-height: 207px;
                
                .list-row{
                    display: flex;
                    align-items: center;
                    min-height: 34px;
                    // border-bottom: 1px solid #ccc;
                    border-bottom: 1px solid #eee;
                    text-align: center;
                    font-size: 16px;
                    >div{
                        flex: 1;
                        line-height: 19px;
                        // text-align: center;
                    }
                    >div:first-child{
                        // text-align: left;
                        // padding-left: 20px;
                    }
                    .factory{
                        width: 100px;
                    }
                }
                .list-row:last-child{
                    border:none;
                }
                .handle{
                    display: flex;
                    justify-content: center;
                    .btn{
                        width: 86px;
                        height: 26px;
                        line-height: 26px;
                        cursor: pointer;
                        background: #fff;
                        color: #333;
                    }
                    .ygd{
                        color: red;
                    }
                }
            }
        }
        .link-list{
            .cc-brand{
                min-width: 100px;
                max-width: 100px;
            }
            .code{
                min-width: 140px;
                max-width: 140px;
            }
            .price{
                min-width: 100px;
                max-width: 100px;
            }
            .handle{
                min-width: 80px;
                max-width: 80px;
            }
        }
        .part-img-list{
            display: flex;
            max-height: 240px;
            flex-wrap: wrap;
            overflow: auto;
            .img-box{
                // width: 200px;
                padding: 10px;
                img{
                    // width: 200px;
                    height: 180px;
                    cursor: pointer;
                }
            }
        }

    }
}
</style>